// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getMessaging, getToken } from "firebase/messaging";
import { getAnalytics } from "firebase/analytics";
import logger from "../../utils/logger";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
export const firebaseConfig = {
    apiKey: "AIzaSyAZO1-jjYfbbTCvuRfefA3B2Nrt5Q25xFY",
    authDomain: "customer-first-web.firebaseapp.com",
    projectId: "customer-first-web",
    storageBucket: "customer-first-web.firebasestorage.app",
    messagingSenderId: "388530027922",
    appId: "1:388530027922:web:fbc575b33af16a8504954b",
    measurementId: "G-5W7DFZQJ7Y",
};

const vapidKey = "BBB4wtgJtmDsGwbXQfDqfXN-OYsuiKgfZRFh6_L8gRjYSZ55RrDpvRFMwodms22_IWhiiyMeJcFyeddX-FOYp0g"

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const messaging = getMessaging(app);

export const generateToken = async () => {
    const permission = await Notification.requestPermission();
    if (permission !== "granted") {
        logger.log("Unable to get permission to notify.");
        return;
    }

    try {
        const registration = await navigator.serviceWorker.register('/firebase-messaging-sw.js');

        const token = await getToken(messaging, {
            vapidKey: vapidKey,
            serviceWorkerRegistration: registration,
        });

        if (token) {
            return token;
        } else {
            logger.log("No registration token available. Request permission to generate one.");
        }
    } catch (error) {
        logger.error("An error occurred while registering service worker or getting token:", error);
    }
};